import "@/App.css";
import { AnimationProvider } from '@/context/AnimationContext';
import { I18nProvider } from '@/context/I18nContext';
import { EditorLayout } from '@/components/editor/EditorLayout';
import { Toaster } from 'sonner';

function App() {
  return (
    <div className="dark">
      <I18nProvider>
        <AnimationProvider>
          <EditorLayout />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: 'hsl(220, 14%, 12%)',
                border: '1px solid rgba(255,255,255,0.06)',
                color: '#e2e8f0',
                fontSize: '12px',
              }
            }}
          />
        </AnimationProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
